import React, { useContext, useEffect, useRef, useState } from 'react';
import { Formik, Field } from 'formik';
import Form, { InputSection } from '../components/Form';
import Input from '../../../ui/Input';
import { DropDown } from '../../../ui/DropDown';
import { GetHook, postEndpoint, putEndpoint } from '../../../api/api';
import {
  PERIOD_URL,
  SCORECARDS_URL,
  SCORECARD_URL,
  USER_URL
} from '../../../api/urls';
import { parseDropdown, parseScorecards } from '../../../utils/parseDropdown';
import { get } from '../../../utils/get';
import Axios from '../../../utils/axios';
import styled from 'styled-components';
import { TitleText, LabelText } from '../../../ui/Text';
import { AttendeeCard } from '../../../components/AttendeeCard';
import Modal from '../../../ui/Modal';
import SearchInput from '../../../ui/SearchInput';
import { EditIcon } from '../../../assets/svg/EditIcon';
import { toast } from 'react-toastify';
import { AuthContext } from '../../../context/AuthContext';
import is from 'date-fns/locale/is/index.js';
import { isIP } from 'net';
import useAuth from '../../../hooks/useAuth';

interface IProps {
  closeModal?: any;
  setHandleSubmit?: any;
  setScorecards?: any;
  scorecards?: any;
  editData?: any;
  isPIP?: any;
}

const AddScorecardForm = ({
  closeModal,
  setHandleSubmit,
  setScorecards,
  scorecards,
  editData,
  isPIP
}: IProps) => {
  const [createRes, createReq] = postEndpoint();
  const [updateRes, updateReq] = putEndpoint();
  const formRef: any = useRef<any>(null);
  const { data: period } = GetHook(`${PERIOD_URL}`);
  const { data: users } = GetHook(`${USER_URL}?limit=1000`);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const auth = useAuth();

  const { isAdmin, authState } = auth;
  const { id } = editData;
  const isAddMode = !id;
  const {
    data: cascadeScorecards,
    error,
    pending,
    reload
  } = GetHook(
    isAdmin()
      ? `${SCORECARDS_URL}?status=active&limit=1000`
      : `${SCORECARDS_URL}?owner_id=${get(
          authState,
          'user.id'
        )}&cascade_for=true&status=active`
  );

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  useEffect(() => {
    setHandleSubmit(() => handleSubmit);
    return () => {};
  }, []);

  const [openModal, setOpenmodal] = useState(false);
  const [owner, setOwner] = useState();
  const addManager = () => {
    setOpenmodal(!openModal);
  };

  useEffect(() => {
    if (!isAddMode) {
      setOwner(get(editData, 'owner'));
      const newEditData = {
        ...editData,
        period: {
          value: get(editData, 'period.id'),
          label: get(editData, 'period.name')
        },
        cascade_from: {
          value: get(editData, 'parent_id'),
          label: get(editData, 'parent.name')
        }
      };
      const fields = ['name', 'period', 'notes', 'cascade_from'];
      fields.forEach(field =>
        formRef.current.setFieldValue(field, newEditData[field], false)
      );
    }
  }, []);

  const AddScorecard = values => {
    const payload = {
      name: get(owner, 'names'),
      period_id: get(values, 'period.value'),
      parent_id: get(values, 'cascade_from.value'),
      notes: get(values, 'notes'),
      owner_id: get(owner, 'id'),
      scorecard_type: get(values, 'scorecard_type.value')

    };

    //toast.error("Kindly cascade on the 2024 BSC. Here's the link https://2024bsc.cpf.or.ke");

    Axios.post(SCORECARD_URL, payload)
      .then(res => {
        console.log(values);
        const { returned_resultset } = res.data;
        setScorecards([returned_resultset[0], ...scorecards]);
        toast.success(
          'Scorecard has been created successfully. Pending approval'
        );
        closeModal();
      })
      .catch(error => {
        console.log(values);
        toast.error(get(error.response.data, 'message'));
      });
  };

  const editScorecard = values => {
    const payload = {
      period_id: get(values, 'period.value'),
      parent_id: get(values, 'cascade_from.value'),
      notes: get(values, 'notes'),
      owner_id: get(owner, 'id'),
      scorecard_type: get(values, 'scorecard_type.value')
    };
    updateReq(`${SCORECARD_URL}/${id}`, payload);
  };

  useEffect(() => {
    const { complete, pending, data } = updateRes;
    if (!pending && complete && data) {
      closeModal();
    }
  }, [closeModal, updateRes]);

  useEffect(() => {
    if (!isAdmin()) {
      setOwner(get(authState, 'user'));
    }
  }, [isAdmin]);

  const handleManagerSearch = e => {
    const filtered = users.filter(user =>
      user.names.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setFilteredUsers(filtered);
  };

  const initialValues = {
    name: '',
    period: '',
    notes: '',
    cascade_from: '',
    scorecard_type: ''
  };



  const periodOptions = parseDropdown(period);
  const cascadeOptions = parseScorecards(cascadeScorecards);

  const scorecadOptions = [{'label':'Regular', 'value':'Regular'}, {'label':'PIP', 'value':'PIP'}, {'label':'Probation', 'value':'Probation'}];

  return (
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      onSubmit={isAddMode ? values => AddScorecard(values) : editScorecard}
    >
      {() => {
        return (
          <Form>
            <InputSection>
              <Field
                name='cascade_from'
                dropdownLabel='Cascade From'
                component={DropDown}
                options={cascadeOptions}
                width='96%'
                isBordered={true}
              />
            </InputSection>
            <InputSection>
              <Field
                name='period'
                dropdownLabel='Period'
                component={DropDown}
                options={periodOptions}
                isBordered={true}
                width='96%'
              />
            </InputSection>
            <InputSection>
              <Field
                name='scorecard_type'
                dropdownLabel='Type'
                component={DropDown}
                options={scorecadOptions}
                width='96%'
                isBordered={true}
              />
            </InputSection>
            <InputSection>
              <OwnerSection>
                {owner ? (
                  <SelectedOwner>
                    <LabelText>Owner</LabelText>
                    <AttendeeCard data={owner} />
                    <div
                      style={{ paddingLeft: '2rem' }}
                      onClick={() => addManager()}
                    >
                      <EditIcon />
                    </div>
                  </SelectedOwner>
                ) : (
                  <>
                    <LabelText>Owner</LabelText>
                    <TitleText onClick={() => addManager()}>
                      Choose Owner <label style={{ color: '#01A8CE' }}>+</label>
                    </TitleText>
                  </>
                )}
                {openModal && (
                  <Modal
                    title='Choose Manager'
                    closeModal={() => setOpenmodal(false)}
                    noFooter={true}
                  >
                    <SearchInput handleChange={handleManagerSearch} />
                    <div style={{ height: '70vh', overflow: 'auto' }}>
                      {(filteredUsers.length ? filteredUsers : users).map(
                        user => (
                          <AttendeeCard
                            key={user.id}
                            setSelected={() => setOwner(user)}
                            data={user}
                            setModalOpen={setOpenmodal}
                          />
                        )
                      )}
                    </div>
                  </Modal>
                )}
              </OwnerSection>
            </InputSection>
           
            <InputSection>
              <Field
                type='textarea'
                name='notes'
                placeholder='Description'
                label='Scorecard description'
                component={Input}
              />
            </InputSection>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddScorecardForm;

const OwnerSection = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  justify-content: space-between;
  margin-top: 1em;
  ${TitleText} {
    text-align: end;
  }
`;

const SelectedOwner = styled.div`
  display: grid;
  grid-template-columns: 3fr 0.1fr;
  align-items: center;
  ${LabelText} {
    grid-column: 1 / span 2;
  }
`;
